import React, { useEffect } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { useModule } from "../../context/ModuleContext";
import { useNavigate } from "react-router-dom";

export default function ModulesLandingPage() {
  const { selectedModule } = useModule();
   const navigate = useNavigate();

    useEffect(() => {
    if (!selectedModule) {
      navigate("/Dashboard1"); // 🔁 Redirect to dashboard
    }
  }, [selectedModule, navigate]);

  if (!selectedModule) {
    return null; // Optionally show nothing while redirecting
  }

  return (
    <div style={{ padding: "2rem" }}>
      <Typography variant="h4" gutterBottom>
        Welcome to {selectedModule.name} Page
      </Typography>

      {selectedModule ? (
        <Box
          sx={{
            backgroundColor: "#f1f1f1",
            padding: "24px",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            marginTop: "20px",
          }}
        >        

          {Array.isArray(selectedModule.functions) && selectedModule.functions.length > 0 ? (
            <Grid container spacing={2}>
              {selectedModule.functions.map((func, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      padding: "16px",
                      borderRadius: "10px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      textAlign: "center",
                    }}
                  >
                    {/* <Typography variant="h6">{func.name}</Typography> */}
                    {/* <Typography variant="body2" color="textSecondary">
                      {func.description}
                    </Typography> */}
                    {func.uriPath && (
                      <Button
                        component={Link}
                        to={func.uriPath}
                        variant="contained"
                        size="small"
                        sx={{ mt: 2 }}
                      >
                        {func.name}
                      </Button>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No functions available.</Typography>
          )}
        </Box>
      ) : (
        <Typography>No module selected.</Typography>
      )}
    </div>
  );
}